import { EmailResponseResult } from '../../../models/EmailResponse'

const _EMAIL_RESPONSE_NO_RESULT_VALUE = 'unknown'

export const isEmailResponseNoResult = (emailResponse: EmailResponseResult | null) => {
  if (!emailResponse) {
    return false
  }
  const { email } = emailResponse
  return !email.length || email.toLowerCase() === _EMAIL_RESPONSE_NO_RESULT_VALUE
}
